import React from "react"
import autobind from "class-autobind"
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRow, TableRowColumn, FloatingActionButton } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import TF from "material-ui/Table/TableFooter"
import TableActionBar from "../../../components/layout/TableActionBar"
import TableFooter from "../../../components/layout/TableFooter"
import strings from "../../../localization/strings"
import * as  userActions from "../../../actions/UserActions"
import { IUserDocument, IHierarchyItem } from "../.../../../../models"
import AppStateStore from "../../../stores/AppStateStore"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import * as userHelper from "../../../helpers/userHelper"
import ChooseHierarchyPickerDialog from "../../../components/hierarchy/choose_hierarchy/ChooseHierarchyPickerDialog"
interface IProps {
    user: IUserDocument
    readonly: boolean
}
interface IState {
    linkedHierarchyIds: string[]
    openAddHierarchyDialog: boolean
    selectedHierarchyIds: string[]
    showHierarchyList: IHierarchyItem[]
    searchText: string
    offset: number
    limit: number
    limitOptions: number[]
    total: number
    showTable: boolean
}

export default class UserDetailsHierarchyTable extends React.Component<IProps, IState>  {
    constructor(props, context) {
        super(props, context)
        this.state = {
            linkedHierarchyIds: this.props.user.LinkedHierarchyIds || [],
            openAddHierarchyDialog: false,
            selectedHierarchyIds: [],
            showHierarchyList: [],
            searchText: "",
            offset: 0,
            limit: 10,
            limitOptions: [5, 10, 100],
            total: 0,
            showTable: true,
        }
        autobind(this)
    }

    componentDidMount() {
        this.setState({ linkedHierarchyIds: this.props.user.LinkedHierarchyIds || [] }, () =>
            this.getShowHierarchyList()
        )
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ linkedHierarchyIds: nextProps.user.LinkedHierarchyIds || [] }, () =>
            this.getShowHierarchyList()
        )
    }

    getShowHierarchyList() {
        const hierarchyList = this.state.linkedHierarchyIds.map(item => hierarchyHelper.getHierarchyItemById(item))
        const filteredHierarchyList = hierarchyList.filter(item => item.Label.toLowerCase().includes(this.state.searchText.toLowerCase()))
        this.setState({
            total: filteredHierarchyList.length,
            showHierarchyList: filteredHierarchyList.slice(this.state.offset, this.state.offset + this.state.limit)
        })
    }

    handelOnCellClick(rowNumber, colId) {
        const clickedHierarchy = this.state.showHierarchyList[rowNumber]
        if (colId === -1) {
            if (this.props.readonly) return
            let selectedHierarchyIds = this.state.selectedHierarchyIds.slice()
            if (this.state.selectedHierarchyIds.find(item => item === clickedHierarchy.Id)) {
                selectedHierarchyIds = selectedHierarchyIds.filter(item => item !== clickedHierarchy.Id)
            }
            else {
                selectedHierarchyIds.push(clickedHierarchy.Id)
            }
            this.setSelectedHierarchyIds(selectedHierarchyIds)
        }
    }

    handleOnRowSelection(result) {
        result === "all" && this.setSelectedHierarchyIds(this.state.showHierarchyList.slice())
        result === "none" && this.setSelectedHierarchyIds([])
    }

    setSelectedHierarchyIds(selectedHierarchyIds) {
        this.setState({ selectedHierarchyIds, showTable: false }, () => this.setState({ showTable: true }))
    }

    onDelete() {
        const user = this.props.user
        user.LinkedHierarchyIds = user.LinkedHierarchyIds.filter(id => !this.state.selectedHierarchyIds.includes(id))
        AppStateStore.setProgressSnackbarContent("loading")
        userActions.updateUser(user.Id, user).then(() => {
            AppStateStore.setProgressSnackbarContent(strings.Hierarchy_deleted_successfully)
            this.setState({
                selectedHierarchyIds: [],
                searchText: ""
            })
        })
    }

    handleAddHierarchy(hierarchyItem: IHierarchyItem) {
        const user = this.props.user
        const linkedHierarchyIds = user.LinkedHierarchyIds || []
        if (linkedHierarchyIds.includes(hierarchyItem.Id)) {
            AppStateStore.setProgressSnackbarContent(strings.Hierarchy_already_added)
        }
        else {
            linkedHierarchyIds.push(hierarchyItem.Id)
            user.LinkedHierarchyIds = linkedHierarchyIds
            AppStateStore.setProgressSnackbarContent("loading")
            userActions.updateUser(user.Id, user)
                .then(() => AppStateStore.setProgressSnackbarContent(strings.Hierarchy_added_successfully))
        }
    }

    render() {
        return (
            <div style={{ position: "relative" }}>
                {!this.props.readonly &&
                    <FloatingActionButton
                        className="fixed-add"
                        style={{ position: "relative", float: "right", right: 50, top: -70 }}
                        secondary
                        onTouchTap={() => this.setState({ openAddHierarchyDialog: true })}
                    >
                        <ContentAdd />
                    </FloatingActionButton>
                }
                <div className="TableActionBar">
                    <TableActionBar
                        rowSelectionCount={this.state.selectedHierarchyIds.length}
                        singleSelectedMessage={strings.Hierarchy_Selected}
                        multipleSelectedMessage={strings.x_Hierarchy_Items_Selected}
                        title={strings.Employee_Hierarchy}
                        onSearch={searchText =>
                            this.setState({
                                searchText,
                                offset: 0,
                                selectedHierarchyIds: [],
                            }, () =>
                                this.getShowHierarchyList()
                            )}
                        searchText={this.state.searchText}
                        onDeleteClick={() => {
                            AppStateStore.setConfirmDialogContent({
                                title: this.state.selectedHierarchyIds.length === 1 ? strings.DELETE_HIERARCHY : strings.DELETE_HIERARCHIES,
                                content: this.state.selectedHierarchyIds.length === 1 ? strings.Are_you_sure_delete_Hierarchy : strings.Are_you_sure_delete_Hierarchies,
                                confirm: () => this.onDelete()
                            })
                        }}
                        readonly={false}
                        onSearchClick={() =>
                            this.setState({
                                offset: 0,
                                selectedHierarchyIds: [],
                            }, () =>
                                this.getShowHierarchyList()
                            )
                        }
                        onCloseSearchClick={() =>
                            this.setState({
                                searchText: "",
                                offset: 0,
                                selectedHierarchyIds: [],
                            }, () =>
                                this.getShowHierarchyList()
                            )
                        }
                    />
                </div>
                {!this.state.linkedHierarchyIds.length ?
                    <h2 style={{ textAlign: "center", marginTop: 25, marginBottom: 25 }}>
                        {strings.This_Employee_has_No_Hierarchies}
                    </h2> :
                    this.state.showHierarchyList.length > 0 ?
                        <Table
                            className="HierarchyTable"
                            onCellClick={this.handelOnCellClick}
                            onRowSelection={this.handleOnRowSelection}
                            multiSelectable={!this.props.readonly}
                            selectable={!this.props.readonly}
                            bodyStyle={{ height: "calc(100vh - 400px)", overflowY: "visible" }}
                        >
                            <TableHeader enableSelectAll={!this.props.readonly}>
                                <TableRow>
                                    <TableHeaderColumn style={{ width: 200 }}>Hierarchy Name</TableHeaderColumn>
                                    <TableHeaderColumn>Path</TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody deselectOnClickaway={false}>
                                {this.state.showHierarchyList.map(item =>
                                    <TableRow selected={this.state.selectedHierarchyIds.includes(item.Id)} key={item.Id}>
                                        <TableRowColumn style={{ width: 200 }}>{item.Label}</TableRowColumn>
                                        <TableRowColumn>{hierarchyHelper.getFullPathLabel(item.Id)}</TableRowColumn>
                                    </TableRow>
                                )}
                            </TableBody>
                            <TF>
                                <TableFooter
                                    total={this.state.total}
                                    offset={this.state.offset}
                                    limit={this.state.limit}
                                    limitOptions={this.state.limitOptions}
                                    onPageClick={offset =>
                                        this.setState({ offset }, () =>
                                            this.getShowHierarchyList()
                                        )
                                    }
                                    onLimitChange={limit =>
                                        this.setState({
                                            limit,
                                            offset: 0
                                        }, () =>
                                            this.getShowHierarchyList()
                                        )
                                    }
                                />
                            </TF>
                        </Table> :
                        <div style={{ textAlign: "center", fontSize: 30, fontWeight: "bold", marginTop: 25 }}>
                            {strings.No_hierarchy_found}
                        </div>
                }
                {this.state.openAddHierarchyDialog &&
                    <ChooseHierarchyPickerDialog
                        getCustomNoAccessErrorStr={(selectedHierarchy: IHierarchyItem) => userHelper.getSupervisorChooseEmployeeDefaultHierarchyItemErrorStr(selectedHierarchy)}
                        handleClose={() => this.setState({ openAddHierarchyDialog: false })}
                        handleSave={this.handleAddHierarchy}
                    />
                }
            </div>
        )
    }
}
